<template>
  <p class="question-points">
    {{ points }}
  </p>
</template>

<style lang="less" scoped>
.question-answer {
  margin: 0;
  padding: 10px;
}
</style>

<script>
const debug = require('debug')('ccs:component:question-point');

export default {
	props: {
		question: [Object]
	},
	computed: {
		points: function() {
			const points = this.question.points;
			if (!points) return '-';

			let result = '-';
			if (points) {
				let type = points.type;
				if (type == 'word') {
					result = points.word_name + ' : ' + (points.meaning_of_kid || '');
				} else if (type == 'sentence') {
					result =
            (points.sentence_en || '') +
            ' ' +
            (points.sentence_cn || '') +
            '<br>' +
            (points.sentence_en_answer || '') +
            ' ' +
            (points.sentence_cn_answer || '');
				} else if (type == 'phonic') {
					result = points.phonic_name;
				} else if (type == 'grammar_level') {
					result =
            (points.grammar_level_en || '') +
            ' : ' +
            (points.grammar_level || '');
				} else if (type == 'reading_strategy' || type == 'reading_style') {
					result = (points.name_en || '') + ' : ' + (points.name_cn || '');
				} else if (type == 'sentence_structure') {
					result =
            (points.sentence_structure || '') + ' : ' + (points.meaning || '');
				}
			}
			return result;
		}
	}
};
</script>
